import React, { createContext, useContext, useState } from 'react';
var RootComponentsContext = createContext();
var RootComponentsProvider = props => {
  var {
    children
  } = props;
  var state = useState(new Map());
  return /*#__PURE__*/React.createElement(RootComponentsContext.Provider, {
    value: state
  }, children);
};
export default RootComponentsProvider;
export var useRootComponents = () => useContext(RootComponentsContext);